interface RefundButtonVisibility {
  isRefundActionAvailable?: boolean;
  isMerchantResolved: boolean;
  isIndividualMerchant: boolean;
  isRefundMerchantCurrencySupported: boolean;
}

export const shouldShowRefundButton = ({
  isRefundActionAvailable,
  isMerchantResolved,
  isIndividualMerchant,
  isRefundMerchantCurrencySupported,
}: RefundButtonVisibility) =>
  Boolean(isRefundActionAvailable && isMerchantResolved && !isIndividualMerchant && isRefundMerchantCurrencySupported);
